// extracted by mini-css-extract-plugin
module.exports = {"modal":"Dependents_modal__1OFGG"};